const SEAT_SIZE = 15;

const TEXT_COLOR = '#010101';
const BACKGROUND_COLOR = '#ffffff';
const SEAT_STROKE_WIDTH = SEAT_SIZE / 25;
const SPACING_HORIZONTAL = Math.round(SEAT_SIZE / 3);
const SPACING_VERTICAL = Math.round(SEAT_SIZE / 3);
const SECTOR_FONT = Math.round((SEAT_SIZE / 3 * 2));
const ROUND_TABLE_FONT = SECTOR_FONT;
const RECTANGLE_TABLE_FONT = SECTOR_FONT;
const GENERAL_ADMISSION_FONT = Math.round((SEAT_SIZE / 3 * 2.5));
const ROW_FONT = Math.round(SECTOR_FONT - (SECTOR_FONT / 10));
const SEAT_FONT = Math.round(SECTOR_FONT - (SECTOR_FONT / 3));
const SEAT_FILL_COLOR = '#b6b6b6';
const SEAT_STROKE_COLOR = '#6d6d6d';
const SECTOR_SHAPE_FILL_COLOR = 'rgb(160,208,130)';
const SECTOR_SHAPE_HIGHLIGHT_FILL_COLOR = 'rgb(255,244,0)';
const SECTOR_HIGHLIGHT_FILL_COLOR = 'rgba(255,205,0,0.62)';
const DRAW_PERIMETER_FILL = 'transparent';
const DRAW_PERIMETER_STROKE_COLOR = 'black';
const DRAW_PERIMETER_STROKE_DASH_ARRAY = 4;
const DRAW_PERIMETER_STROKE_WIDTH = SEAT_SIZE / 30;

const GENERAL_ADMISSION_FILL = SEAT_FILL_COLOR;
const GENERAL_ADMISSION_STROKE_COLOR = SEAT_STROKE_COLOR;
const GENERAL_ADMISSION_STROKE_WIDTH = SEAT_STROKE_WIDTH;

const SHAPE_FILL = SEAT_FILL_COLOR;
const SHAPE_STROKE_COLOR = SEAT_STROKE_COLOR;
const SHAPE_STROKE_WIDTH = SEAT_STROKE_WIDTH;

const TRANSFORMATION_BOX_FILL = 'none';
const TRANSFORMATION_BOX_STROKE = 'blue';
const TRANSFORMATION_BOX_STROKE_WIDTH = DRAW_PERIMETER_STROKE_WIDTH;
const TRANSFORMATION_BOX_ROTATION_ICON_Y_OFFSET = -SEAT_SIZE;
const TRANSFORMATION_BOX_RECT_ICON_SIZE = SEAT_SIZE / 5;
const TRANSFORMATION_BOX_ICON_FILL = 'blue';
const TRANSFORMATION_BOX_ICON_SIZE = SEAT_SIZE / 2;
const TRANSFORMATION_BOX_CONTROL_ITEM_AREA = SEAT_SIZE;

const CONTEXT_MASK_FILL = '#757575';
const CONTEXT_MASK_OPACITY = 0.3;

const ROUND_TABLE_SIZE = SEAT_SIZE * 3;
const ROUND_TABLE_SEATS = 6;
const ROUND_TABLE_GAPS = 0;
const SECTOR_ROWS = 3;
const SECTOR_SEATS = 6;

const RECTANGLE_TABLE_WIDTH = SEAT_SIZE * 3;
const RECTANGLE_TABLE_HEIGHT = SEAT_SIZE * 2;
const RECTANGLE_TABLE_SEATS_NORTH = 2;
const RECTANGLE_TABLE_SEATS_SOUTH = 2;
const RECTANGLE_TABLE_SEATS_EAST = 1;
const RECTANGLE_TABLE_SEATS_WEST = 1;

const OBJECT_MOVEMENT_SPEED = 5;
const OBJECT_MOVEMENT_MODIFIER_MULTIPLIER = 10;

const GRID_COLOR = SHAPE_FILL;
const GRID_STROKE_WIDTH = SEAT_SIZE / 60;

const LABEL_COLOR_BRIGHT = BACKGROUND_COLOR;
const LABEL_COLOR_DARK = TEXT_COLOR;

const DUPLICATE_OFFSET = 24;

export {
    SEAT_SIZE,
    SEAT_STROKE_WIDTH,
    SPACING_HORIZONTAL,
    SPACING_VERTICAL,
    SECTOR_FONT,
    SEAT_FILL_COLOR,
    SEAT_STROKE_COLOR,
    SECTOR_SHAPE_FILL_COLOR,
    SECTOR_SHAPE_HIGHLIGHT_FILL_COLOR,
    SECTOR_HIGHLIGHT_FILL_COLOR,
    ROW_FONT,
    SEAT_FONT,
    DRAW_PERIMETER_FILL,
    DRAW_PERIMETER_STROKE_COLOR,
    DRAW_PERIMETER_STROKE_DASH_ARRAY,
    DRAW_PERIMETER_STROKE_WIDTH,
    TRANSFORMATION_BOX_FILL,
    TRANSFORMATION_BOX_STROKE,
    TRANSFORMATION_BOX_STROKE_WIDTH,
    TRANSFORMATION_BOX_ROTATION_ICON_Y_OFFSET,
    TRANSFORMATION_BOX_RECT_ICON_SIZE,
    TRANSFORMATION_BOX_ICON_SIZE,
    TRANSFORMATION_BOX_ICON_FILL,
    ROUND_TABLE_SIZE,
    ROUND_TABLE_SEATS,
    ROUND_TABLE_GAPS,
    TRANSFORMATION_BOX_CONTROL_ITEM_AREA,
    CONTEXT_MASK_FILL,
    CONTEXT_MASK_OPACITY,
    RECTANGLE_TABLE_WIDTH,
    RECTANGLE_TABLE_HEIGHT,
    RECTANGLE_TABLE_SEATS_NORTH,
    RECTANGLE_TABLE_SEATS_EAST,
    RECTANGLE_TABLE_SEATS_SOUTH,
    RECTANGLE_TABLE_SEATS_WEST,
    OBJECT_MOVEMENT_SPEED,
    OBJECT_MOVEMENT_MODIFIER_MULTIPLIER,
    GENERAL_ADMISSION_FILL,
    GENERAL_ADMISSION_STROKE_COLOR,
    GENERAL_ADMISSION_STROKE_WIDTH,
    SHAPE_FILL,
    SHAPE_STROKE_COLOR,
    SHAPE_STROKE_WIDTH,
    GRID_COLOR,
    GRID_STROKE_WIDTH,
    TEXT_COLOR,
    BACKGROUND_COLOR,
    GENERAL_ADMISSION_FONT,
    LABEL_COLOR_BRIGHT,
    LABEL_COLOR_DARK,
    ROUND_TABLE_FONT,
    RECTANGLE_TABLE_FONT,
    SECTOR_ROWS,
    SECTOR_SEATS,
    DUPLICATE_OFFSET,
};
